import type { CampaignFilters } from '@/api/routes/campaigns/types';

export const filters: CampaignFilters = {
  org: [],
  priority: [],
  tags: [],
  ad_video_type: [],
  ad_tags: [],
};
